import i18next from "i18next";
import LngDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";
// The CDN `moment` global has every locale's data baked in; this bundled
// npm copy only ships "en" - these imports give it real de/sl data too
// (MUI's calendars resolve locale through this copy, not the CDN one).
import bundledMoment from "moment";
import "moment/locale/de";
import "moment/locale/sl";

// A moment instance locks in its locale's week-start at creation time, so
// the async patch below (in the "languageChanged" handler) can lose the
// race with a component built before it fires. Patch "en" synchronously
// here instead - "de"/"sl" already default to Monday.
moment.updateLocale("en", { week: { dow: 1, doy: 4 } });
bundledMoment.updateLocale("en", { week: { dow: 1, doy: 4 } });

let i18 = i18next
  .use(LngDetector)
  .use(XHR)
  .init({
    nsSeparator: false,
    keySeparator: false,
    fallbackLng: false,

    /*lng : "de",
	debug: true,*/

    detection: {
      // order and from where user language should be detected
      order: ["navigator", "localStorage"],

      // keys or params to lookup language from
      lookupLocalStorage: "i18nextLng",

      // cache user language on
      caches: ["localStorage"],

      // optional expire and domain for set cookie
    },
    backend: {
      loadPath: "/static/locales/{{lng}}/{{ns}}.json",
      allowMultiLoading: false,
      // allow cross domain requests
      crossDomain: false,

      // allow credentials on cross domain requests
      withCredentials: false,

      //  parse: (data) => {
      //  	let obj = null
      //  	try {
      //   		obj = JSON.parse(data);
      // 	}
      // 	catch (e) {
      // 		console.log("error parse translations", e);
      // 	}
      //   console.log("translation is :",  obj); return obj
      // },
    },

    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
      format: function (value, formatting, lng) {
        if (value === undefined) {
          console.warn("undefiend value passed to: ", formatting);
          return "";
        }

        if (value instanceof Date) return moment(value).format(formatting);
        return value.toString();
      },
    },
  });

let _translations = {};

let _cachedDetectedLocale = undefined;

let originalT = i18.t;

i18.t = function () {
  let value = originalT.apply(i18, arguments);

  if (!_cachedDetectedLocale) {
    _cachedDetectedLocale = getDetectedLocale();
    console.log("detect locale", _cachedDetectedLocale);
  }

  // console.log("translate", arguments[0], "to:", value, " locale:", _cachedDetectedLocale);

  if (
    _translations[_cachedDetectedLocale] != undefined &&
    _translations[_cachedDetectedLocale][value] != undefined
  ) {
    value = _translations[_cachedDetectedLocale][value];
    // console.log("new value:", value);
  }

  return value;
};

export const setTranslations = (newTranslations) => {
  _translations = newTranslations;
};

let detectedLocale = "en";
let datePickerLocale = "en";

const datePickerLocaleDe = {
  months:
    "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split(
      "_"
    ),
  monthsShort: "Jan_Feb_Mar_Apr_Mai_Jun_Jul_Aug_Sep_Okt_Nov_Dez".split("_"),
  weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split(
    "_"
  ),
  weekdaysShort: "Son_Mon_Die_Mit_Don_Fre_Sam".split("_"),
  weekdaysLetter: [],
};

const datePickerLocaleSl = {
  months:
    "Januar_Februar_Marec_April_Maj_Junij_Julij_Avgust_September_Oktober_November_December".split(
      "_"
    ),
  monthsShort: "Jan_Feb_Mar_Apr_Maj_Jun_Jul_Avg_Sep_Okt_Nov_Dec".split("_"),
  weekdays: "Nedelja_Ponedeljek_Torek_Sreda_Četrtek_Petek_Sobota".split("_"),
  weekdaysShort: "Ned_Pon_Tor_Sre_Čet_Pet_Sob".split("_"),
  weekdaysLetter: [],
};

i18next.on("languageChanged", function (lng) {
  // console.log("ON LANGUAGE CHANGED", lng);

  // console.log("i18", i18.store.data); //get <lang>.translation => [string]

  // "en"'s moment locale defaults to Sunday as the week start; force Monday
  // everywhere, regardless of detected language (de/sl already default to it).
  moment.locale(lng);
  moment.updateLocale(moment.locale(), { week: { dow: 1, doy: 4 } });
  bundledMoment.locale(lng);
  bundledMoment.updateLocale(bundledMoment.locale(), { week: { dow: 1, doy: 4 } });
  detectedLocale = lng;

  if (lng.indexOf("de") >= 0) {
    datePickerLocale = datePickerLocaleDe;
  } else if (lng.indexOf("sl") >= 0) {
    datePickerLocale = datePickerLocaleSl;
  } else {
    datePickerLocale = "en";
  }

  // console.log("darte pick", datePickerLocale);
});

export const getDatePickerLocale = () => {
  return datePickerLocale;
};

export const getDetectedLocale = () => {
  return detectedLocale;
};

export const getDetectedCounty = () => {
  return detectedLocale.split("-")[0];
};

export const getLocaleName = () => {
  let l = getDetectedCounty();
  _cachedDetectedLocale = l;
  switch (l) {
    case "en": {
      return "name_en";
      break;
    }

    case "de": {
      return "name_de";
      break;
    }

    case "sl": {
      return "name_sl";
      break;
    }
  }

  return "name_en";
};

export const getDetectLocaleShort = () => {
  const locale = getDetectedCounty();
  _cachedDetectedLocale = locale;

  console.log("getDetectLocaleShort", locale);

  switch (locale) {
    case "en": {
      return "en";
      break;
    }

    case "de": {
      return "de";
      break;
    }

    case "sl": {
      return "sl";
      break;
    }
  }

  return "en";
};

export default i18next;
